import { ClientAttachmentId } from 'owa-client-ids';
import CalendarItem from 'owa-service/lib/contract/CalendarItem';

export const enum AddToCalendarStatus {
    disabled,
    available,
    adding,
    succeeded,
    failed,
}

export enum IcsCalendarEventType {
    UNKNOWN = 0,
    SINGLE_EVENT_ICS = 1,
    MULTIPLE_EVENT_ICS = 2,
}

interface IcsPreviewState {
    calendarItem: CalendarItem;
    dialogMessage?: string; // To be displayed if ics attachment has multiple events
    isIcsAttachmentLoading: boolean;
    icsCalendarEventType: IcsCalendarEventType; // Its value depends upon the type of the ics attachment file like single-event, multiple-events or unknown
    attachmentId: ClientAttachmentId;
    addToCalendarStatus: AddToCalendarStatus;
    errorMessage: string;
}

export default IcsPreviewState;
